/**
 * Yamaneco Ghost Theme JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Normalize paths so route logic works for locale subdirectories (e.g., /en/)
    function normalizePath(path) {
        if (!path) return '/';
        
        let normalized = new URL(path, window.location.origin).pathname;
        
        if (normalized === '/en') {
            normalized = '/';
        } else if (normalized.startsWith('/en/')) {
            normalized = normalized.replace(/^\/en/, '');
        }
        
        if (normalized.length > 1 && normalized.endsWith('/')) {
            normalized = normalized.slice(0, -1);
        }
        
        return normalized || '/';
    }
    
    // Mobile Menu Toggle - Enhanced for Ghost navigation
    const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    const navLinks = document.getElementById('nav-links');
    const ghostNav = document.querySelector('.nav'); // Ghost navigation
    
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function() {
            // Toggle custom nav-links if exists
            if (navLinks) {
                navLinks.classList.toggle('open');
            }
            
            // Toggle Ghost navigation
            if (ghostNav) {
                ghostNav.classList.toggle('open');
            }
            
            this.classList.toggle('active');
        });
        
        // Close mobile menu when clicking on navigation links
        document.querySelectorAll('.nav-link, .nav a').forEach(link => {
            link.addEventListener('click', function() {
                if (navLinks) navLinks.classList.remove('open');
                if (ghostNav) ghostNav.classList.remove('open');
                mobileMenuToggle.classList.remove('active');
            });
        });
    }
    
    // Newsletter Form Handling
    const newsletterForm = document.querySelector('.newsletter-form');
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const email = this.querySelector('[data-members-email]').value;
            const submitBtn = this.querySelector('.newsletter-btn');
            const btnText = submitBtn.querySelector('.btn-text');
            const btnLoading = submitBtn.querySelector('.btn-loading');
            const successMsg = document.querySelector('.newsletter-success');
            const errorMsg = document.querySelector('.newsletter-error');
            
            // Show loading state
            if (btnText && btnLoading) {
                btnText.style.display = 'none';
                btnLoading.style.display = 'inline';
            }
            submitBtn.disabled = true;
            
            // Hide previous messages
            if (successMsg) successMsg.style.display = 'none';
            if (errorMsg) errorMsg.style.display = 'none';
            
            // Submit to Ghost Members API
            fetch('/members/api/send-magic-link/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    emailType: 'subscribe'
                })
            })
            .then(response => response.json())
            .then(data => {
                // Reset button state
                if (btnText && btnLoading) {
                    btnText.style.display = 'inline';
                    btnLoading.style.display = 'none';
                }
                submitBtn.disabled = false;
                
                if (data.success !== false) {
                    // Show success message
                    if (successMsg) successMsg.style.display = 'block';
                    newsletterForm.reset();
                } else {
                    // Show error message
                    if (errorMsg) errorMsg.style.display = 'block';
                }
            })
            .catch(error => {
                console.error('Newsletter signup error:', error);
                
                // Reset button state
                if (btnText && btnLoading) {
                    btnText.style.display = 'inline';
                    btnLoading.style.display = 'none';
                }
                submitBtn.disabled = false;
                
                // Show error message
                if (errorMsg) errorMsg.style.display = 'block';
            });
        });
    }
    
    // Smooth Scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
    
    // Ghost's built-in search functionality handles search automatically
    
    // Form input focus states
    document.querySelectorAll('.newsletter-input, .form-input').forEach(input => {
        input.addEventListener('focus', function() {
            this.style.borderColor = 'var(--yamaneco-teal)';
        });
        
        input.addEventListener('blur', function() {
            this.style.borderColor = 'var(--soft-teal)';
        });
    });
    
    // Enhanced filter tab interactions with loading states
    document.querySelectorAll('.filter-tab').forEach(tab => {
        tab.addEventListener('click', function(e) {
            // Add loading state to clicked tab
            this.classList.add('filter-loading');
            
            // Remove loading state after navigation (or timeout)
            setTimeout(() => {
                this.classList.remove('filter-loading');
            }, 1000);
        });
    });
    
    // Smooth scroll to content after filter selection
    if (window.location.pathname.includes('/tag/')) {
        const blogSection = document.querySelector('.blog-section');
        if (blogSection) {
            blogSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
    
    // Add enhanced class to blog filters for progressive enhancement
    const blogFilters = document.querySelector('.blog-filters');
    if (blogFilters) {
        blogFilters.classList.add('js-enhanced');
    }
    
    // Ensure publications card links open in a new tab
    document.querySelectorAll('.publication-entry .publication-body a').forEach(link => {
        link.setAttribute('target', '_blank');
        const relValues = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        relValues.add('noopener');
        relValues.add('noreferrer');
        link.setAttribute('rel', Array.from(relValues).join(' '));
    });

    // Move speakerdeck iframe embeds from the body into one or more talk media slots
    document.querySelectorAll('#talks .publication-entry').forEach(entry => {
        const iframes = Array.from(entry.querySelectorAll('.publication-body iframe'));
        const mediaContainer = entry.querySelector('.talk-media');
        const firstSlot = mediaContainer ? mediaContainer.querySelector('.talk-image') : null;

        if (!iframes.length || !mediaContainer || !firstSlot) {
            return;
        }

        const mountIframe = (slot, iframe) => {
            slot.innerHTML = '';
            iframe.removeAttribute('height');
            iframe.removeAttribute('width');
            iframe.setAttribute('loading', 'lazy');
            iframe.style.backgroundColor = 'transparent';
            iframe.setAttribute('allowtransparency', 'true');
            slot.appendChild(iframe);
        };

        mountIframe(firstSlot, iframes[0]);

        iframes.slice(1).forEach(iframe => {
            const newSlot = document.createElement('div');
            newSlot.classList.add('talk-image');
            mediaContainer.appendChild(newSlot);
            mountIframe(newSlot, iframe);
        });
    });

    // Lazy loading for images (if not handled by Ghost)
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                    imageObserver.unobserve(img);
                }
            });
        });
        
        document.querySelectorAll('img[data-src]').forEach(img => {
            imageObserver.observe(img);
        });
    }
    
    // Enhanced header scroll behavior with blur effects
    let lastScrollY = window.scrollY;
    const header = document.querySelector('.site-header');
    let scrollTimeout;
    
    function updateHeaderState() {
        const currentScrollY = window.scrollY;
        
        if (!header) return;
        
        // Add blur/transparency classes based on scroll position
        if (currentScrollY <= 50) {
            header.classList.add('at-top');
            header.classList.remove('scrolled');
        } else {
            header.classList.remove('at-top');
            header.classList.add('scrolled');
        }
        
        // Hide/show header based on scroll direction
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
            // Scrolling down - hide header
            header.style.transform = 'translateY(-100%)';
        } else {
            // Scrolling up - show header
            header.style.transform = 'translateY(0)';
        }
        
        lastScrollY = currentScrollY;
    }
    
    // Optimized scroll listener with requestAnimationFrame
    function onScroll() {
        if (scrollTimeout) return;
        
        scrollTimeout = requestAnimationFrame(() => {
            updateHeaderState();
            scrollTimeout = null;
        });
    }
    
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Initialize header state
    updateHeaderState();
    
    // Set active navigation state for all pages (desktop and mobile)
    function setActiveNavigation() {
        const currentPath = normalizePath(window.location.pathname);
        const navItems = document.querySelectorAll('.nav a, .nav-links a');
        
        navItems.forEach(link => {
            link.classList.remove('nav-current');

            const linkPath = normalizePath(new URL(link.href).pathname);
            
            // Exact match for home page (only when actually on home page)
            if (currentPath === '/' && linkPath === '/') {
                link.classList.add('nav-current');
            }
            // Exact match for other pages
            else if (currentPath === linkPath) {
                link.classList.add('nav-current');
            }
            // Blog-related pages (blog posts, tag pages) should match blog nav (but not home page)
            else if (currentPath.startsWith('/blog/') && 
                     linkPath === '/blog') {
                link.classList.add('nav-current');
            }
            // Service detail pages should match services nav
            else if (currentPath.startsWith('/services/') && 
                     linkPath === '/services') {
                link.classList.add('nav-current');
            }
            // Project detail pages should match projects nav
            else if (currentPath.startsWith('/projects/') && 
                     linkPath === '/projects') {
                link.classList.add('nav-current');
            }
        });
    }
    
    // Initialize navigation active state
    setActiveNavigation();
    
    // Set active state for blog filter tabs
    function setBlogFilterActive() {
        const currentPath = normalizePath(window.location.pathname);
        const filterTabs = document.querySelectorAll('.filter-tab');
        
        filterTabs.forEach(tab => {
            tab.classList.remove('active');
            
            // Get the tab's URL path
            const tabPath = normalizePath(new URL(tab.href).pathname);
            
            // Exact match for current page
            if (currentPath === tabPath) {
                tab.classList.add('active');
            }
        });
    }
    
    // Initialize blog filter active state if filter tabs exist
    if (document.querySelector('.filter-tab')) {
        setBlogFilterActive();
    }
    
    // FAQ Accordion functionality
    const faqItems = document.querySelectorAll('.faq-item');
    
    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');
        const icon = question ? question.querySelector('.faq-icon') : null;
        
        if (question && answer) {
            question.addEventListener('click', function() {
                const isOpen = answer.classList.contains('open');
                
                // Close all other FAQ items
                faqItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        const otherAnswer = otherItem.querySelector('.faq-answer');
                        const otherIcon = otherItem.querySelector('.faq-icon');
                        if (otherAnswer) {
                            otherAnswer.classList.remove('open');
                        }
                        if (otherIcon) {
                            otherIcon.classList.remove('rotated');
                        }
                    }
                });
                
                // Toggle current item
                if (isOpen) {
                    answer.classList.remove('open');
                    if (icon) icon.classList.remove('rotated');
                } else {
                    answer.classList.add('open');
                    if (icon) icon.classList.add('rotated');
                }
            });
        }
    });
    
    
    // Contact Form Submission
    const contactFormSection = document.getElementById('contact-form');
    const contactForm = contactFormSection && contactFormSection.querySelector('form');
    if (contactForm) {
        contactForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            
            const submitButton = this.querySelector('.form-submit');
            const messagesDiv = document.getElementById('form-messages');
            const successDiv = messagesDiv.querySelector('.form-success');
            const errorDiv = messagesDiv.querySelector('.form-error');
            
            // Reset messages
            messagesDiv.style.display = 'none';
            successDiv.style.display = 'none';
            errorDiv.style.display = 'none';
            
            // Show loading state
            const originalText = submitButton.textContent;
            submitButton.textContent = 'Sending...';
            submitButton.disabled = true;
            
            try {
                // Submit form data to the action endpoint
                const response = await fetch(this.action, {
                    method: 'POST',
                    body: new FormData(this),
                    headers: {
                        'Accept': 'application/json'
                    }
                });
                
                // Check if response is successful (200-299 status codes)
                if (response.ok) {
                    // For external services like Formspree, also check response content
                    try {
                        const responseData = await response.json();
                        // Some services return success: true/false in JSON
                        if (responseData.ok === false || responseData.success === false) {
                            throw new Error('Form service returned error');
                        }
                    } catch (jsonError) {
                        // If response is not JSON or parsing fails, assume success if status is ok
                        console.log('Response is not JSON, assuming success based on status code');
                    }
                    
                    // Show success message
                    successDiv.style.display = 'block';
                    messagesDiv.style.display = 'block';
                    
                    // Reset form
                    this.reset();
                } else {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }
                
            } catch (error) {
                console.error('Form submission error:', error);
                
                // Show error message
                errorDiv.style.display = 'block';
                messagesDiv.style.display = 'block';
            } finally {
                // Reset button
                submitButton.textContent = originalText;
                submitButton.disabled = false;
            }
        });
    }
});


// Export for potential module usage
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {};
}
